import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import {  FormLabel, Nav,  Offcanvas, ToggleButtonGroup } from 'react-bootstrap';
import { FormControl, FormControlLabel, FormGroup, Grid, Radio, RadioGroup, Switch, ToggleButton } from '@mui/material';

const logo = require('../images/CWS.png');
const Navibar = ({setVersion, version}) => {
   
    // Version?
    // true == V2
    // false == V1
    const equimentString = "With Equipment";
    const typeString = "With Type";
 const [versionLabel, setLabelVersion] = useState(version? equimentString: typeString);


 const ChangeVersion = (e) => {
     if(e.target.value == "true"){
         setVersion(true);
     }
     else setVersion(false);
     // if(versionLabel ===typeString){
         //     setVersion(true);
         //     setLabelVersion(equimentString)
         // }
         // else {
             //     setVersion(false);
             //     setLabelVersion(typeString) 
             // }
             
 }


    return (
        <Navbar style={{backgroundColor:"#263238",minHeight:"5vh"}} expand={false}>
            <Grid container  justifyContent="space-between"
                                     alignItems="center"   > 
            <Grid item xs={2}>

                <Navbar.Brand href="/">
                    <img
                        src={String(logo)}
                        width="350"
                        
                        className="d-inline-block align-top"
                        alt="React Bootstrap logo"
                        style={{marginLeft:"30px"}}
                        />
                </Navbar.Brand>
                        </Grid>

            <Grid item xs={6}>
       
             
            </Grid>
         
                        
            <Grid item xs={1}>
                <Navbar.Toggle aria-controls="offcanvasNavbar" style={{ backgroundColor:"#90a4ae"}}/>
                </Grid>
               
               
                <Navbar.Offcanvas
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                    placement="end"
                    style={{color:"#263238", backgroundColor:"#b0bec5" }}
           
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel">Pages</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav>
                            <Nav.Link href="/parkview">Park overview</Nav.Link>
                            {/* <Nav.Link href="/wtg">WTG</Nav.Link>
                            <Nav.Link href="/OilSensor">Oil Sensor</Nav.Link> */}
                            <Nav.Link href="/HowToUploadExcel">Configurate new park</Nav.Link>
                            <Nav.Link href="/WTG">WTG overview</Nav.Link>
                            <Nav.Link href="http://192.168.1.123">Marine controller</Nav.Link>
                            <Nav.Link href="/Oilsensor">Oilsensor</Nav.Link>
                       
                        </Nav>
                        <h6>
                            <br/>
                            <br/>
                            Change layout version to display
                        </h6>
                       

                        <FormControl>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={version}
        onChange={ChangeVersion}
      >
        <FormControlLabel value={true} control={<Radio/>} label={equimentString} />
        <FormControlLabel value={false} control={<Radio />} label={typeString} />
      </RadioGroup>
    </FormControl>
                        {/* <ToggleButtonGroup
                            color="primary"
                            value={version}
                            exclusive
                            onChange={ChangeVersion}
                            >
                            <ToggleButton value={true}>{equimentString}</ToggleButton>
                            <ToggleButton value={false}>{typeString}</ToggleButton>
                            </ToggleButtonGroup> */}
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Grid>
        </Navbar>
    );
};
export default Navibar;
